"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Placement = exports.innerPlacement = exports.placementEnum = void 0;

/**
 * popper placement 枚举
 */
var placementEnum;
exports.placementEnum = placementEnum;

(function (placementEnum) {
  placementEnum["top"] = "top";
  placementEnum["topLeft"] = "top-start";
  placementEnum["topRight"] = "top-end";
  placementEnum["right"] = "right";
  placementEnum["rightTop"] = "right-start";
  placementEnum["rightBottom"] = "right-end";
  placementEnum["bottom"] = "bottom";
  placementEnum["bottomLeft"] = "bottom-start";
  placementEnum["bottomRight"] = "bottom-end";
  placementEnum["left"] = "left";
  placementEnum["leftTop"] = "left-start";
  placementEnum["leftBottom"] = "left-end";
})(placementEnum || (exports.placementEnum = placementEnum = {})); // const direction = ['top', 'left', 'bottom', 'right'];
// const Placement: string[] = direction.reduce((pre, cur) => {
//     pre.push(cur, `${cur}-start`, `${cur}-end`);
//     return pre;
// }, []);


var innerPlacement = ['top', 'topLeft', 'topRight', 'right', 'rightTop', 'rightBottom', 'bottom', 'bottomLeft', 'bottomRight', 'left', 'leftTop', 'leftBottom'];
exports.innerPlacement = innerPlacement;
var Placement = innerPlacement;
exports.Placement = Placement;